import(/* webpackMode: "eager" */ "/app/apps/ashtrom-corporate/app/[locale]/(layout)/not-found.tsx")